
export enum AllocationPlanSection {
    Welcome = 1,
    HRAssist = 2,
    ProposeAllocations = 3,
    ApproveAllocations = 4,
    SupportAndTraining = 5,
    SupportAndTrainingShortGuides = 6,
}